export var InviteReasonCode;
(function (InviteReasonCode) {
    InviteReasonCode["INVITE_INVALID"] = "INVITE_INVALID";
    InviteReasonCode["INVITE_EXPIRED"] = "INVITE_EXPIRED";
    InviteReasonCode["ALREADY_ORG_MEMBER"] = "ALREADY_ORG_MEMBER";
    InviteReasonCode["ALREADY_MEMBER_OF_ORGANIZATION"] = "ALREADY_MEMBER_OF_ORGANIZATION";
    InviteReasonCode["PENDING_APPROVAL_REQUIRED"] = "PENDING_APPROVAL_REQUIRED";
    InviteReasonCode["FORBIDDEN_NOT_OWNER"] = "FORBIDDEN_NOT_OWNER";
    InviteReasonCode["CONFLICT_REQUEST_ALREADY_PROCESSED"] = "CONFLICT_REQUEST_ALREADY_PROCESSED";
    InviteReasonCode["DOMAIN_DNS_UNAVAILABLE"] = "DOMAIN_DNS_UNAVAILABLE";
})(InviteReasonCode || (InviteReasonCode = {}));
//# sourceMappingURL=invite-reason-code.enum.js.map